
export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-yellow-500 to-yellow-600 py-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="flex items-center mb-4 md:mb-0">
            <img
              src="https://public.readdy.ai/ai/img_res/31c24993-8488-4121-abbf-60f0c81b8404.png"
              alt="Rich Luxury Home Builder LLC"
              className="h-10 w-auto"
            />
          </div>

          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-black text-sm font-medium">
              © 2025 Rich Luxury Home Builder LLC. All rights reserved.
            </p>
          </div>

          <div className="flex items-center space-x-1">
            <a
              href="/privacy-policy"
              className="text-black text-sm font-medium hover:underline whitespace-nowrap cursor-pointer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
